import { useState } from "react";

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState("");

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2000);
  };

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("input");
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  const handleWeibo = () => {
    const url = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(
      window.location.href,
    )}&title=${encodeURIComponent(`${title} - 星辰影视`)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    showToast("正在打开微博分享（演示）");
  };

  return (
    <div className="relative">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-sm text-foreground-500 mr-1">分享：</span>
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md border border-background-300 bg-background-50 hover:border-primary-300 text-sm text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-link" aria-hidden="true" />
          复制链接
        </button>
        <button
          type="button"
          onClick={handleWeibo}
          className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md border border-background-300 bg-background-50 hover:border-accent-300 text-sm text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-weibo-fill text-accent-500" aria-hidden="true" />
          分享到微博
        </button>
        <button
          type="button"
          onClick={() => showToast("请打开微信客户端进行分享（前端演示）")}
          className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md border border-background-300 bg-background-50 hover:border-primary-300 text-sm text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-wechat-fill text-primary-500" aria-hidden="true" />
          微信朋友圈
        </button>
      </div>

      {toast && (
        <div className="absolute -bottom-11 left-0 px-3 py-2 rounded-md bg-foreground-900 text-background-50 text-xs whitespace-nowrap z-10">
          {toast}
        </div>
      )}
    </div>
  );
}